var map = {
	"./demos/basic/index.ts": 1175,
	"./demos/collapse/index.ts": 15997,
	"./demos/loading/index.ts": 41865,
	"./demos/slots/index.ts": 44314,
	"./demos/withBubble/index.ts": 94861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37079;